<!--@format-->
<template>
    <div class="mdf-add-activity-type-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>{{ title }}</h3>
                <div class="widget-header-actions">
                    <div class="svg-container widget-close-button" @click="closeWidget">
                        <widget-close-svg />
                    </div>
                </div>
            </div>
            <div class="content-wrapper">
                <div class="form-row">
                    <app-input
                        v-model="activity.activity"
                        label="Activity Type"
                        placeholder="Write Activity Type"
                    />
                    <app-input-chips
                        label="Proof of Performance Requirements"
                        placeholder="Type in POP"
                        :items="activity.pop"
                        @click:add="handleAddPOP"
                    />
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="close-button" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="handleSave"> Save </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppInput = () => import('@/components/common/app-input');
const AppInputChips = () => import('@/components/common/app-input-chips');

import EventBus from '@/scripts/event-bus.js';
import { LogLevel } from '@/scripts/logger';

export default {
    name: 'mdf-add-activity-type-widget',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
        'widget-close-svg': WidgetCloseSvg,
        'app-input-chips': AppInputChips,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            activity: {
                activity: null,
                pop: [],
            },

            editId: null,
        };
    },

    computed: {
        activityToEdit() {
            const { options } = this.widget;
            return options.activity;
        },

        title() {
            const { options } = this.widget;
            return options.title;
        },

        isMasterAgencyUser() {
            return this.$store.getters.isMasterAgencyUser;
        },

        isOrganizationUser() {
            return this.$store.getters.isOrganizationUser;
        },

        isMDFRequestSettingsManager() {
            return (
                this.isMasterAgencyUser ||
                this.isOrganizationUser ||
                this.$store.state.user.roles.includes('MdfRequestSettingsManager')
            );
        },
    },

    created() {
        this.validateRoles();

        if (this.activityToEdit) {
            this.activity.activity = this.activityToEdit.activity;
            const popListEdit = this.activityToEdit.pop.map(({ name }) => name);
            this.activity.pop = popListEdit;
            this.editId = this.activityToEdit.id;
        }
    },

    methods: {
        validateRoles() {
            if (!this.isMDFRequestSettingsManager) {
                this.closeWidget();
                const errorMessage =
                    'You need additional permissions in order to perform this action.';
                this.$helpers.showFailNotification(errorMessage, { level: LogLevel.INFO });
            }
        },

        handleAddPOP(pop) {
            this.activity.pop.push(pop);
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handleSave() {
            if (this.editId !== null) {
                const payload = {
                    activity: this.activity,
                    id: this.editId,
                };
                EventBus.$emit('mdf-add-activity-type:update', payload);
            } else {
                const payload = {
                    activity: this.activity,
                };
                EventBus.$emit('mdf-add-activity-type:save', payload);
            }
            this.closeWidget();
        },
    },
};
</script>

<style>
.mdf-add-activity-type-widget.widget .content-wrapper {
    padding: 24px;
}

.mdf-add-activity-type-widget .content-wrapper .form-row {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
}

.mdf-add-activity-type-widget .content-wrapper .form-row .app-input .input-container {
    display: flex;
    align-items: center;
    column-gap: 8px;
}

.mdf-add-activity-type-widget .content-wrapper .form-row label {
    font-weight: 500;
}

.mdf-add-activity-type-widget .app-button.normal {
    padding: 12px 60px;
}

.mdf-add-activity-type-widget .app-button.normal.close-button {
    background: transparent;
    color: #382153;
    border: 1px solid #cac6cb;
}

.mdf-add-activity-type-widget .app-button.normal.close-button:hover {
    background: #e1e0e5;
    color: #382153;
}
</style>
